import React from 'react'
import Prop from '../componentes/Prop'
import { ICON_TYPES } from '../constantes/iconos.ts'
import styled from 'styled-components'
import { Calendar, dayjsLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import dayjs from 'dayjs'
import 'dayjs/locale/es'

dayjs.locale('es')

const Calendario = () => {
    const localizer = dayjsLocalizer(dayjs)
    const eventos = [
        {
            start: dayjs('2025-04-29T12:00:00').toDate(),
            end: dayjs('2025-04-29T22:00:00').toDate(),
            title: 'Prueba'
        }
    ]
    const component = {
        event: props => {
            console.log('props', props)
            return (
                <div onClick={() => console.log('first')}>
                    {props.title}
                </div>
            )
        }
    }
    return (
        <>
            <Prop titulo='CALENDARIO' icono={ICON_TYPES.CALENDARIO} />
            <Section>
                <Calendar
                    style={{ height: '100%', width: '80%', margin: 'auto' }}
                    events={eventos}
                    toolbar={true}
                    localizer={localizer}
                    views={['month']}
                    components={component}
                />
            </Section>

        </>
    )
}

const Section = styled.section`
    width: 100vw;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
`

export default Calendario